export default function makeRequest(url, { method, headers }, done) {
  const xhr = new XMLHttpRequest();
  xhr.open(method, url);
  if (headers) {
    Object.entries(headers).forEach(([header, value]) => {
      xhr.setRequestHeader(header, value);
    });
  }
  xhr.onload = () => {
    done(null, xhr.response);
  };
  xhr.onerror = () => {
    done(xhr.response);
  };
  xhr.send();
}



// WEBPACK FOOTER //
// ./scripts/utils/xhr.js